import { createContext } from 'react';

import type { MintServiceLocatorType } from '../types.js';

export const MintServiceLocator = createContext<MintServiceLocatorType | null>(
  null,
);
